import Ad from '@/entities/Ad.js';
import Post from '@/entities/Post.js';
import api from '@/services/Api';

export default {
  getList({ term, sourceProfileId, brandId, platform, orderBy, order, page, limit }) {
    const data = {};
    if (term) {
      data['term'] = term;
    }
    if (orderBy) {
      data['order_by'] = orderBy;
    }
    if (order) {
      data['order'] = order;
    }
    if (sourceProfileId) {
      data['source_profile_id'] = sourceProfileId;
    }
    if (brandId) {
      data['brand_id'] = brandId;
    }
    if (platform) {
      data['platform'] = platform;
    }
    if (page) {
      data['page'] = page;
    }
    if (limit) {
      data['limit'] = limit;
    }

    const query = new URLSearchParams(data).toString();

    return api().get('/posts?' + query)
      .then(resp => resp.map(i => new Post(i)));
  },

  get(id) {
    return api().get('/post/' + id)
      .then(resp => new Post(resp));
  },

  update(entity) {
    return api().put('/post/' + entity.id, entity.toObject())
      .then(resp => new Post(resp));
  },

  getEmbed(id) {
    return api().get('/post/' + id + '/embed');
  },

  getAdsFromPost(id, { page, limit }) {
    const data = {};
    if (page) {
      data['page'] = page;
    }
    if (limit) {
      data['limit'] = limit;
    }

    const query = new URLSearchParams(data).toString();
    const queryString = query ? '?' + query : '';

    return api().get('/post/' + id + '/ads' + queryString)
      .then(resp => resp.map(i => new Ad(i)));
  },
};
